import type { NamingMode } from "../lib/types";

// Single source of truth for the naming-mode choices + their explanations.
const OPTIONS: { value: NamingMode; label: string; hint: string }[] = [
  {
    value: "unique",
    label: "Unique (recommended)",
    hint: "timestamp + random + filename — never overwrites, keeps the name.",
  },
  {
    value: "timestamped",
    label: "Timestamped",
    hint: "timestamp + filename — readable and almost always unique.",
  },
  {
    value: "exact",
    label: "Exact filename",
    hint: "filename as-is under the prefix — predictable, but re-uploading the same name overwrites.",
  },
  {
    value: "anonymous",
    label: "Anonymous",
    hint: "timestamp + random, drops the original filename entirely.",
  },
];

export const NAMING_LABEL: Record<NamingMode, string> = Object.fromEntries(
  OPTIONS.map((o) => [o.value, o.label]),
) as Record<NamingMode, string>;

/** Object-naming mode picker, shared by the wizard, the add-destination modal,
 *  and the destination detail settings. */
export function NamingSelect({
  value,
  onChange,
}: {
  value: NamingMode;
  onChange: (v: NamingMode) => void;
}) {
  return (
    <div>
      <select
        className="input"
        value={value}
        onChange={(e) => onChange(e.target.value as NamingMode)}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <p className="mt-1 text-xs text-ink-subtle">
        {OPTIONS.find((o) => o.value === value)?.hint}
      </p>
    </div>
  );
}
